import FRApi from './_frApi';
import httpClient from '@/apis/base/httpclient';

class FrTemplateCustomAPI extends FRApi {
  constructor() {
    super();
  }
  controllerName = 'frTemplateCustoms';

  /**
   * Lấy các chỉ tiêu con có trong công thức chỉ tiêu tổng
   * @param {*} param chứa id báo cáo
   * dtnga3 (18.09.2022)
   */
  getDefault(param) {
    let request = {
      url: this.getAPIUrl() + '/getDefault',
      data: param,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Cập nhật list chỉ tiêu thiết lập
   * dtnga3 (15.09.2022)
   */
  updateMultiple(param) {
    let request = {
      url: this.getAPIUrl() + '/updateMultiple',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Cập nhật công thức chỉ tiêu
   * dtnga3 (18.09.2022)
   */
  updateFormula(param) {
    let request = {
      url: this.getAPIUrl() + '/updateFormula',
      data: param,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Lấy các chỉ tiêu con có trong công thức chỉ tiêu tổng
   * @param {*} param chứa id chỉ tiêu thiết lập
   * dtnga3 (18.09.2022)
   */
  getDetailFormula(param) {
    let request = {
      url: this.getAPIUrl() + '/getDetailFormula',
      data: param,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy các chỉ tiêu con có trong công thức chỉ tiêu tổng
   * @param {*} param chứa id chỉ tiêu thiết lập
   * dtnga3 (18.09.2022)
   */
  getDefaultTemplateFormula(param) {
    let request = {
      url: this.getAPIUrl() + '/getDefaultTemplateFormula',
      data: param,
    };
    return httpClient.getAsync(request);
  }
}

export default new FrTemplateCustomAPI();
